export default __webpack_public_path__ + "static/media/b146dc8d75d05f3.f4371364.mp3";